module.exports = __webpack_public_path__ + "static/media/map.a294220f.png";